
import FilterSelect from "./FilterSelect.vue";

export default {
    components: {FilterSelect},
    props: ['category', 'filters'],
    data() {
        return {

        }
    },
    computed: {
        hasClearAll() {
            return Object.values(this.filters.values).some(value => value !== null && value !== '');
        },
        navigationResetUrl() {
            const navigation = Object.values(this.filters.navigation || {})[0];
            return navigation ? navigation.reset_url : null;
        }
    },
    methods: {
        select(key, value){
            this.$emit('select', key, value);
        },
        clear(key){
            this.$emit('clear', key);
        },
        clearAll(event){
            if (event) {
                if (this.navigationResetUrl && (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0)) return;
                event.preventDefault();
            }
            this.$emit('clear-all');
        },
    },
}
